// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"SalesOrderTable_shipment-table__wrapper__hdlHc","shipment-table":"SalesOrderTable_shipment-table__3rd1L"};